<template>
  <div>
    <h2 class="m_title d-flex ty__z" @click="status_toggle = !status_toggle">
      {{ $t('myapplication.myapplication_details.fields.status') }} : {{ $vuetify.rtl ? status.status_name_ar : status.status_name_en }}<v-spacer class="hidden_lr10"></v-spacer><span class="regdate__text d-flex align-center">({{ $t('myapplication.myapplication_details.fields.registration') }}<v-spacer class="hidden_lr10"></v-spacer>{{ status.modified_date }})</span>
      <v-spacer></v-spacer>
      <v-btn icon class="toggle_btn ty2 align-self-center" :class="{'actv' : status_toggle}"><v-icon >mdi-chevron-down</v-icon></v-btn>
      <v-spacer class="hidden_lr5"></v-spacer>
    </h2>
    <div v-if="status_toggle">
      <v-data-table
        :headers="$getHeaderType1(status_headerTxt, status_headers)"
        :items="statusList"
        :items-per-page="statusList.length"
        hide-default-footer
        disable-pagination
        disable-sort
        class="new__type__table__view"
        :mobile-breakpoint="MobileBreakPoint"
      >
        <template v-slot:item="{ item, index }">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>
              <p>{{item.stage_name_ar}}</p>
              <p>{{item.stage_name_en}}</p>
            </td>
            <td>
              <p>{{item.name_ar}}</p>
              <p>{{item.name_en}}</p>
            </td>
            <td>{{item.created_date}}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <h2 class="m_title d-flex" @click="applicants_toggle = !applicants_toggle">
      {{ $t('myapplication.myapplication_details.fields.applicant_owner') }}
      <v-spacer></v-spacer>
      <v-btn icon class="toggle_btn ty2 d-flex align-self-center" :class="{'actv' : !applicants_toggle}"><v-icon>mdi-chevron-up</v-icon></v-btn>
      <v-spacer class="hidden_lr5"></v-spacer>
    </h2>
    <div>
      <v-data-table
        :headers="$getHeaderType1(applicants_headerTxt, applicants_headers)"
        :items="applicants"
        :items-per-page="applicants.length"
        hide-default-footer
        disable-pagination
        disable-sort
        class="new__type__table__view"
        :mobile-breakpoint="MobileBreakPoint"
      >
        <template v-slot:item="{ item, index }">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>
              <p>{{item.name_ar}}</p>
              <p>{{item.name_en}}</p>
            </td>
            <td>
              <p>{{item.address_ar}}</p>
              <p>{{item.address_en}}</p>
            </td>
            <td>{{item.nationality_code}}</td>
            <td>{{item.residence_country_code}}</td>
            <td>
              <p>{{item.applicant_type_name_ar}}</p>
              <p>{{item.applicant_type_name_en}}</p>
            </td>
          </tr>
        </template>
      </v-data-table>

      <!-- applicants_toggle : S -->
      <div v-for="(item, index) in applicantHistorys" :key="index" v-show="applicants_toggle" class="floating__table__wrap">
        <div class="floating__title">{{ $t('myapplication.myapplication_details.fields.former') }} ({{ $t('myapplication.myapplication_details.fields.recorded_date') }} {{item.receipt_date}})</div>

        <v-data-table
          :headers="$getHeaderType1(applicants_headerTxt, applicants_headers)"
          :items="item.applicants"
          :items-per-page="item.applicants.length"
          hide-default-footer
          disable-pagination
          disable-sort
          class="new__type__table__view"
          :mobile-breakpoint="MobileBreakPoint"
        >
          <template v-slot:item="{ item, index }">
            <tr>
              <td>{{ index + 1 }}</td>
              <td >
                <p>{{item.name_ar}}</p>
                <p>{{item.name_en}}</p>
              </td>
              <td>
                <p>{{item.address_ar}}</p>
                <p>{{item.address_en}}</p>
              </td>
              <td>{{item.nationality_code}}</td>
              <td>{{item.residence_country_code}}</td>
              <td>
                <p>{{item.applicant_type_name_ar}}</p>
                <p>{{item.applicant_type_name_en}}</p>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <!-- applicants_toggle : E -->
    </div>


    <h2 class="m_title d-flex" @click="inventors_toggle = !inventors_toggle">
      {{ $t('myapplication.myapplication_details.fields.inventors') }}
      <v-spacer></v-spacer>
      <v-btn icon class="toggle_btn ty2 d-flex align-self-center" :class="{'actv' : !inventors_toggle}"><v-icon>mdi-chevron-up</v-icon></v-btn>
      <v-spacer class="hidden_lr5"></v-spacer>
    </h2>
    <div>
      <v-data-table
        :headers="$getHeaderType1(inventors_headerTxt, inventors_headers)"
        :items="inventors"
        :items-per-page="inventors.length"
        hide-default-footer
        disable-pagination
        disable-sort
        class="new__type__table__view"
        :mobile-breakpoint="MobileBreakPoint"
      >
        <template v-slot:item="{ item, index }">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>
              <p>{{item.name_ar}}</p>
              <p>{{item.name_en}}</p>
            </td>
            <td>
              <p>{{item.address_ar}}</p>
              <p>{{item.address_en}}</p>
            </td>
            <td>{{item.nationality_code}}</td>
            <td>{{item.residence_country_code}}</td>
          </tr>
        </template>
      </v-data-table>
      <div v-for="(item, index) in inventorsHistorys" :key="index" v-show="inventors_toggle" class="floating__table__wrap">
        <div class="floating__title">{{ $t('myapplication.myapplication_details.fields.former') }} ({{ $t('myapplication.myapplication_details.fields.recorded_date') }} {{item.receipt_date}})</div>

        <v-data-table
          :headers="$getHeaderType1(inventors_headerTxt, inventors_headers)"
          :items="item.inventors"
          :items-per-page="item.inventors.length"
          hide-default-footer
          disable-pagination
          disable-sort
          class="new__type__table__view"
          :mobile-breakpoint="MobileBreakPoint"
        >
          <template v-slot:item="{ item, index }">
            <tr>
              <td>{{ index + 1 }}</td>
              <td >
                <p>{{item.name_ar}}</p>
                <p>{{item.name_en}}</p>
              </td>
              <td>
                <p>{{item.address_ar}}</p>
                <p>{{item.address_en}}</p>
              </td>
              <td>{{item.nationality_code}}</td>
              <td>{{item.residence_country_code}}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>


    <h2 class="m_title d-flex" @click="representatives_toggle = !representatives_toggle">
      {{ $t('myapplication.myapplication_details.fields.representative') }}
      <v-spacer></v-spacer>
      <v-btn icon class="toggle_btn ty2 d-flex align-self-center" :class="{'actv' : !representatives_toggle}"><v-icon>mdi-chevron-up</v-icon></v-btn>
      <v-spacer class="hidden_lr5"></v-spacer>
    </h2>
    <div>
      <v-data-table
        :headers="$getHeaderType1(representatives_headerTxt, representatives_headers)"
        :items="representatives"
        :items-per-page="representatives.length"
        hide-default-footer
        disable-pagination
        disable-sort
        class="new__type__table__view"
        :mobile-breakpoint="MobileBreakPoint"
      >
        <template v-slot:item="{ item, index }">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>
              <p>{{item.name_ar}}</p>
              <p>{{item.name_en}}</p>
            </td>
            <td>
              <p>{{item.address_ar}}</p>
              <p>{{item.address_en}}</p>
            </td>
            <td>{{item.nationality_code}}</td>
            <td>{{item.residence_country_code}}</td>
            <td>
              <p>{{ item.agent_type_name_ar }}</p>
              <p>{{ item.agent_type_name_en }}</p>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div v-for="(item, index) in representativesHistorys" :key="index" v-show="representatives_toggle" class="floating__table__wrap">
        <div class="floating__title">{{ $t('myapplication.myapplication_details.fields.former') }} ({{ $t('myapplication.myapplication_details.fields.recorded_date') }} {{item.receipt_date}})</div>

        <v-data-table
          :headers="$getHeaderType1(representatives_headerTxt, representatives_headers)"
          :items="item.representatives"
          :items-per-page="item.representatives.length"
          hide-default-footer
          disable-pagination
          disable-sort
          class="new__type__table__view"
          :mobile-breakpoint="MobileBreakPoint"
        >
          <template v-slot:item="{ item, index }">
            <tr>
              <td>{{ index + 1 }}</td>
              <td >
                <p>{{item.name_ar}}</p>
                <p>{{item.name_en}}</p>
              </td>
              <td>
                <p>{{item.address_ar}}</p>
                <p>{{item.address_en}}</p>
              </td>
              <td>{{item.nationality_code}}</td>
              <td>{{item.residence_country_code}}</td>
              <td>
                <p>{{ item.agent_type_name_ar }}</p>
                <p>{{ item.agent_type_name_en }}</p>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>
    <h2 class="m_title d-flex" v-if="licenseeList.length > 0">
      {{ $t('myapplication.myapplication_details.fields.licensee') }}
    </h2>
    <div v-if="licenseeList.length > 0">
      <v-data-table
        :headers="$getHeaderType1(license_headerTxt, license_headers)"
        hide-default-footer
        :items="licenseeList"
        :items-per-page="licenseeList.length"
        class="new__type__table__view"
        :mobile-breakpoint="MobileBreakPoint"
      >
        <template v-slot:item.no="{ item, index }">
          {{ index + 1}}
        </template>
        <template v-slot:item.name="{ item }">
          <p>{{item.name_ar}}</p>
          <p>{{item.name_en}}</p>
        </template>
        <template v-slot:item.address="{ item }">
          <p>{{item.address_ar}}</p>
          <p>{{item.address_en}}</p>
        </template>
        <template v-slot:item.license_type_code="{ item }">
          <p>{{item.license_type_name_ar}}</p>
          <p>{{item.license_type_name_en}}</p>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
export default {
  props: {
    seq: {
      type: String
    }
  },
  data () {
		return {
      MobileBreakPoint:0,
      status_toggle : false,
      status_headerTxt : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ '#', 'stage_name','status','date' ]
      },
      status_headers: [
        { text: '#', align: 'center', value: 'no', width:'50'},
        { text: this.$t('myapplication.myapplication_details.fields.stage_name'), align: 'center', sortable: false, value: 'stage_name', width:'250' },
        { text: this.$t('myapplication.myapplication_details.fields.status'), align: 'center', sortable: false, value: 'name' },
        { text: this.$t('myapplication.myapplication_details.fields.date'), align: 'center', value: 'created_date', width:'100' }
      ],
      statusList : [],
      status : {
        status_name_ar : '',
        status_name_en : '',
        modified_date : ''
      },

      applicants_toggle : false,
      inventors_toggle: false,
      representatives_toggle: false,

      applicants_headerTxt : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ '#', 'name','address','nationality_country_code','residence_country_code', 'applicant_type' ]
      },
      applicants_headers: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('myapplication.myapplication_details.fields.name'), align: 'center', value: 'name' , width:'250'},
        { text: this.$t('myapplication.myapplication_details.fields.address'), align: 'center', value: 'address' },
        { text: this.$t('myapplication.myapplication_details.fields.nationality_country_code'), align: 'center', value: 'natcc', width:'100'  },
        { text: this.$t('myapplication.myapplication_details.fields.residence_country_code'), align: 'center', value: 'rdcc', width:'100'  },
        { text: this.$t('myapplication.myapplication_details.fields.applicant_type'), align: 'center', value: 'applicant_type_code', width: '120' },
      ],
      applicants : [],
      applicantHistorys : [],
      inventors_headerTxt : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ '#', 'name','address','nationality_country_code','residence_country_code' ]
      },
      inventors_headers : [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('myapplication.myapplication_details.fields.name'), align: 'center', value: 'name', width:'250' },
        { text: this.$t('myapplication.myapplication_details.fields.address'), align: 'center', value: 'address' },
        { text: this.$t('myapplication.myapplication_details.fields.nationality_country_code'), align: 'center', value: 'natcc', width:'100'  },
        { text: this.$t('myapplication.myapplication_details.fields.residence_country_code'), align: 'center', value: 'rdcc', width:'100'  }
      ],
      inventors : [],
      inventorsHistorys: [],

      representatives_headerTxt : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ '#', 'name','address','nationality_country_code','residence_country_code', 'agent_type' ]
      },
      representatives_headers : [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('myapplication.myapplication_details.fields.name'), align: 'center',value: 'name', width:'250'  },
        { text: this.$t('myapplication.myapplication_details.fields.address'), align: 'center',value: 'address' },
        { text: this.$t('myapplication.myapplication_details.fields.nationality_country_code'), align: 'center',value: 'rdcc', width:'100'  },
        { text: this.$t('myapplication.myapplication_details.fields.residence_country_code'), align: 'center',value: 'natcc', width:'100'  },
        { text: this.$t('myapplication.myapplication_details.fields.agent_type'), align: 'center',value: 'agent_type_code', width: '150' }
      ],
      representatives : [],
      representativesHistorys : [],

      license_headerTxt : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ '#', 'name', 'address', 'nationality_country_code', 'residence_country_code', 'licensee_type' ]
      },
      license_headers : [
        { text: '#', align: 'center', sortable: false, value: 'no', width:50 },
        { text: 'Name', align: 'center', value: 'name', width:150 },
        { text: 'Address', align: 'center', value: 'address' },
        { text: 'Nationlity', align: 'center', value: 'nationality_code' , width:100 },
        { text: 'Residence', align: 'center', value: 'residence_country_code', width:100 },
        { text: 'License Type', align: 'center', value: 'license_type_code', width:150 },
      ],
      licenseeList: [],
      expand8 : false
    }
  },
  mounted(){
    this.fnGetStatusInfo()
    this.fnGetStatusList()

    this.fnGetApplicants()
    this.fnGetApplicantHistorys()

    this.fnGetInventors()
    this.fnGetInventorsHistorys()

    this.fnGetRepresentatives()
    this.fnGetRepresentativesHistorys()

    this.fnGetLicensees()
  },
  methods : {
    fnGetStatusInfo(){
      requestApi({
        url: '/applications/' + this.seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.status.status_name_ar = res.data.status_name_ar
            this.status.status_name_en = res.data.status_name_en
            this.status.modified_date = res.data.modified_date
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetStatusInfo()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetStatusList(){
      requestApi({
        url: '/applications/' + this.seq + '/status',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = i + 1
            }
            this.statusList = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetStatusList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetApplicants(){
      requestApi({
        url: '/applications/' + this.seq + '/applicants',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.applicants = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetApplicants()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetApplicantHistorys(){
      requestApi({
        url: '/applications/' + this.seq + '/applicants/history',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.applicantHistorys = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetApplicantHistorys()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetInventors(){
      requestApi({
        url: '/applications/' + this.seq + '/inventors',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.inventors = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetInventors()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetInventorsHistorys(){
      requestApi({
        url: '/applications/' + this.seq + '/inventors/history',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.inventorsHistorys = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetInventorsHistorys()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetRepresentatives(){
      requestApi({
        url: '/applications/' + this.seq + '/representatives',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.representatives = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetRepresentatives()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetRepresentativesHistorys(){
      requestApi({
        url: '/applications/' + this.seq + '/representatives/history',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.representativesHistorys = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetRepresentativesHistorys()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetLicensees() {
      requestApi({
        url: '/application/'+ this.seq +'/licensees',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.licenseeList = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetLicensees()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }
  }
}
</script>